/* eslint-env browser */

'use strict';

const { h, Component } = require('phy');
const FetchHandler = require('../../deal/frontend/FetchHandler');

const { APPLIED, ERROR, QUALIFIED } = require('../constants');
const ApplyPromoCodeComponent = require('../components/apply_promo_code_component');
const NotificationContainer = require('./notification_container');

class ApplyPromoCodeContainer extends Component {
  constructor(props) {
    super(props);
    this.handleApplyClick = this.handleApplyClick.bind(this);
    this.promoApplied = this.promoApplied.bind(this);
    this.promoAppliedError = this.promoAppliedError.bind(this);
    this.showStickyFooter = this.showStickyFooter.bind(this);

    this.intervalId = null;
    this.url = `/deals/promo_codes/associate?event_name=${props.promoEvent}`;
    this.notificationCounter = 0;

    this.state = {
      promoApplied: null,
    };
  }

  promoAppliedError() {
    this.setState({
      errorMessage: this.props.promoApplyCodeErrorText,
      notificationKlass: '.error',
      promoApplied: ERROR,
    });
  }

  promoApplied(response) {
    // we can receive 200 response but promo might not be QUALIFIED
    // we should show an error in this case
    if (response.status.toUpperCase() === QUALIFIED) {
      this.setState({
        notificationKlass: '.success',
        promoApplied: APPLIED,
        successMessage: response.message,
      });
      this.showStickyFooter();
    } else {
      this.promoAppliedError();
    }
  }

  handleApplyClick(e) {
    e.preventDefault();
    this.fetchHandler = new FetchHandler({
      url: this.url,
      errorHandlers: [this.promoAppliedError],
      successHandlers: [this.promoApplied],
    });
    this.fetchHandler.send();
  }

  showStickyFooter() {
    // show after the notification fades
    const max = 3500;
    const interval = 250;
    let count = 0;
    this.intervalId = setInterval(() => {
      const node = document.querySelector('.promo-code-v2 .notification');
      if (count < max && node) {
        count += interval;
      } else {
        const el = document.querySelector(
          '#sticky-footer .promo-v2-sticky-footer'
        );
        if (el) el.classList.remove('ls-hide');
        clearInterval(this.intervalId);
      }
    }, interval);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  render() {
    this.notificationCounter++;
    switch (this.state.promoApplied) {
      case APPLIED: {
        return h(NotificationContainer, {
          ...this.props,
          messageText: this.state.successMessage,
          notificationKlass: this.state.notificationKlass,
          key: String(this.notificationCounter),
        });
      }
      case ERROR: {
        return h(
          '.apply-code-error-wrapper',
          h(ApplyPromoCodeComponent, {
            ...this.props,
            handleApplyClick: this.handleApplyClick,
          }),
          h(NotificationContainer, {
            ...this.props,
            messageText: this.state.errorMessage,
            notificationKlass: this.state.notificationKlass,
            key: String(this.notificationCounter),
          })
        );
      }
      default: {
        return h(ApplyPromoCodeComponent, {
          ...this.props,
          handleApplyClick: this.handleApplyClick,
        });
      }
    }
  }
}

module.exports = ApplyPromoCodeContainer;
